import React from 'react'
import "../styles/app.css"

const ButtonRegistaration = () => {
  return (
   <a href="https://www.youtube.com/@ai-lviv">
         <button className='scroll__btn'>
            Трансляція 
        </button>
    </a>
  )
}

export default ButtonRegistaration
